import { Link } from "react-router-dom"

function Methods() {
    return (
        <section className="courses-three section-space2" id="courses">
            <div className="container">
                <div className="sec-title sec-title--center wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                    <h6 className="sec-title__tagline">metodlar</h6>
                    <h3 className="sec-title__title"><span className="sec-title__title__shape">KERAKLI</span> <span className="sec-title__title__text">METODLAR</span></h3>
                </div>
                <div className="row gutter-y-30">
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/3I">3I metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/3I">3I metodi</Link></h3>
                                    <p className="course-card__text">
                                        Innovatsiya, Integratsiya, Individualizatsiya: yangi texnologiyalarni tatbiq etish, fanlararo yondashuv, individual о‘quv ehtiyojlariga e’tibor
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/3I" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/CLIL">CLIL metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/CLIL">CLIL metodi</Link></h3>
                                    <p className="course-card__text">
                                        Fan va til integratsiyasi: bir vaqtning о‘zida til va fan mazmunini о‘rgatish
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/CLIL" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/SQ3R">SQ3R metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/SQ3R">SQ3R metodi</Link></h3>
                                    <p className="course-card__text">
                                        Matn bilan ishlash usuli: Survey (kо‘zdan kechirish), Question (savollar), Read (о‘qish), Recite (takrorlash), Review (kо‘rib chiqish)
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/SQ3R" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/GRASPS">GRASPS metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/GRASPS">GRASPS metodi</Link></h3>
                                    <p className="course-card__text">
                                        Muammoli vaziyatlarni yechishga yо‘naltirilgan ta’lim modeli: Maqsad, Rol, Auditoriya, Vazifa, Mahsulot, Standartlar
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/GRASPS" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/3I">WHERETO metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/WHERETO">WHERETO metodi</Link></h3>
                                    <p className="course-card__text">
                                        О‘quv jarayonini samarali rejalashtirish: Maqsadlarni belgilash va resurslarni boshqarish
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/WHERETO" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/SMART">SMART metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/SMART">SMART metodi</Link></h3>
                                    <p className="course-card__text">
                                        Maqsadlarni aniqlash: Spetsifik, О‘lchanadigan, Erishiladigan, Ahamiyatli, Muddatli
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/SMART" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="course-card wow fadeInUp animated" data-wow-duration="1500ms" data-wow-delay="00ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInUp" }}>
                            <div className="course-card__image">
                                <img src="/assets/images/course-1-1.svg" alt="Metod" />
                                <div className="course-card__ratings">
                                    <div className="eduhive-ratings">
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                        <span className="eduhive-ratings__icon">
                                            <i className="fa fa-star"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="course-card__content pb-3">
                                <div className="course-card__content__top">
                                    <div className="course-card__category">Metod</div>
                                </div>
                                <h3 className="course-card__title"><Link to="/method/qosh_daraxt">Qo'sh daraxt metodi</Link></h3>
                            </div>
                            <div className="course-card__hover" style={{ backgroundImage: "url(/assets/images/course-card-bg-1-1.png)" }}>
                                <div className="course-card__hover__content">
                                    <div className="course-card__content__top course-card__content__top--hover">
                                        <div className="course-card__category">Metod</div>
                                    </div>
                                    <h3 className="course-card__title course-card__title--hover"><Link to="/method/qosh_daraxt">Qo'sh daraxt metodi</Link></h3>
                                    <p className="course-card__text">
                                        Grafik organayzer asosida bilim va kо‘nikmalarni tizimlashtirish, mavzular о‘rtasidagi о‘zaro bog‘liqlikni aniqlash, fikrlash va mantiqiy tahlil qilishni rivojlantirishga xizmat qiladi
                                    </p>
                                    <div className="course-card__ratings course-card__ratings--hover">
                                        <div className="eduhive-ratings">
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                            <span className="eduhive-ratings__icon">
                                                <i className="fa fa-star"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <Link to="/method/qosh_daraxt" className="course-card__btn eduhive-btn eduhive-btn--border">
                                        <span>Metodni ko'rish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="/assets/images/courses-shape-3-1.png" alt="shape" className="courses-three__shape-one" />
            <img src="/assets/images/courses-shape-3-2.png" alt="shape" className="courses-three__shape-two" />
            <div className="courses-three__box-one"></div>
            <div className="courses-three__box-two"></div>
        </section >
    )
}

export default Methods